export default __webpack_public_path__ + "static/media/communication.6a668038.png";